import api from '../utils/api';
import { User, GitHubContributor } from '../types';
import { cacheService } from './cacheService';

export const getProfile = async (userId?: string): Promise<User> => {
  // Se userId for fornecido, verificar cache primeiro
  if (userId) {
    const cachedProfile = cacheService.getCachedProfile(userId);
    if (cachedProfile) {
      return cachedProfile;
    }
  }

  const response = await api.get('/profile');
  const profile = response.data;

  // Salvar no cache se tiver userId
  if (userId) {
    cacheService.setCachedProfile(userId, profile);
  }

  return profile;
};

export const updateProfile = async (data: { displayName?: string; photoURL?: string }): Promise<User> => {
  const response = await api.put('/profile', data);
  return response.data;
};

export const changePassword = async (currentPassword: string, newPassword: string): Promise<void> => {
  await api.post('/profile/change-password', {
    currentPassword,
    newPassword,
  });
};

export const getAvailableGitHubContributors = async (organizationId: string): Promise<GitHubContributor[]> => {
  const response = await api.get(`/profile/github-contributors?organizationId=${organizationId}`);
  return response.data;
};

export const associateGitHub = async (githubUsername: string): Promise<User> => {
  const response = await api.post('/profile/associate-github', {
    githubUsername,
  });
  return response.data;
};

export const disassociateGitHub = async (): Promise<User> => {
  const response = await api.delete('/profile/github-association');
  return response.data;
};

export const uploadProfilePhoto = async (file: File): Promise<{ photoURL: string; user: User }> => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/profile/upload-photo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};


